"use strict";
exports.__esModule = true;
function setToLocalStorage(key, value, lastTry) {
    if (lastTry === void 0) { lastTry = false; }
    try {
        var newVal = typeof value === 'object' ? JSON.stringify(value) : value;
        localStorage.setItem(key, newVal);
    }
    catch (error) {
        if (lastTry) {
            console.warn('Could not set to local storage', error);
        }
        else {
            localStorage.clear();
            setToLocalStorage(key, value, true);
        }
    }
}
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.get = function (key) {
        try {
            return localStorage.getItem(key);
        }
        catch (error) {
            return null;
        }
    };
    LocalStorage.set = function (key, value) {
        setToLocalStorage(key, value);
    };
    LocalStorage.remove = function (key) {
        localStorage.removeItem(key);
    };
    return LocalStorage;
}());
exports["default"] = LocalStorage;
